import React, { useState } from 'react'
import './CountDownCyrcleTimer.css'
import { useEffect, useRef } from 'react';

const CountDownCyrcleTimer = ({ timeBetweenLastUpdate,timeTillEnd }) => {
  
  const calculatePercentage = (currentTime, maxTime) => {

    const slope = 100 / maxTime;
    const percentage = slope * currentTime;
    return Math.max(0, percentage); // Omezí hodnotu na minimálně 0%
  };
 
  useEffect(() => {
    // Pokud je ještě čas
    if(timeTillEnd <= 0){
        const circle = document.getElementById("circle");
        let procent = calculatePercentage(  Math.abs(timeTillEnd), timeBetweenLastUpdate);
  
        // Uprava kruhového grafu
        circle.style.strokeDashoffset = `calc(440 - (440 * ${procent}) / 100)`;
    
        // Ještě než přijme řidič
        if(!timeBetweenLastUpdate){
          document.querySelector(".number").innerHTML = 
          `<div className="number">
              <h2 id="min"></h2>  
              <p>Přijatá obj.</p>
          </div>`
        } else {
            document.querySelector(".number").innerHTML = 
            `<div className="number">
                <h2 id="min">${Math.abs(timeTillEnd)}</h2>  
                <p>minut zbývá</p>
            </div>`
        }
    // Po uplynutí času
    } else {
        document.querySelector(".number").innerHTML = 
              `<div className="number">
                  <h2 id="min"></h2>  
                  <p>ještě chvilinku</p>
              </div>`
      }
  }, );



  return (
    <div className="containerCard">
        <div className="card">
            <div className="box">
                <div className="percent">
                    <svg>         
                        <circle cx="70" cy="70" r="70"></circle>
                        <circle cx="70" cy="70" r="70" id="circle"></circle>
                    </svg>
                    <div className="number">
                        <h2 id="min"></h2>  
                        <p>minut zbývá</p>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
  )
}

export default CountDownCyrcleTimer
